import { render, staticRenderFns } from "./OpenMoji.vue?vue&type=template&id=245880ec&scoped=true"
import script from "./OpenMoji.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenMoji.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpenMoji.vue?vue&type=style&index=0&id=245880ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245880ec",
  null
  
)

export default component.exports